import { createContext } from 'react';
import { CommandManager } from '../../commands/CommandManager';
import CanvasSession from '../../services/CanvasSession';
import {
  AppState,
  Coordinate,
  LineSegment,
  SelectionCoordinates,
  SelectionMode,
  ViewBox,
} from '../../types';

export interface IAppStateContext {
  appState: AppState;
  session: CanvasSession;
  selectedElements: string[];
  setSelectedElements: React.Dispatch<React.SetStateAction<string[]>>;
  hoverElement: string | null;
  setHoverElement: React.Dispatch<React.SetStateAction<string | null>>;
  selectionCoordinates: SelectionCoordinates;
  setSelectionCoordinates: React.Dispatch<
    React.SetStateAction<SelectionCoordinates>
  >;
  selectionMode: SelectionMode;
  setSelectionMode: React.Dispatch<React.SetStateAction<SelectionMode>>;
  showDebugger: boolean;
  showAllSnaplines: boolean;
  setShowAllSnaplines: React.Dispatch<React.SetStateAction<boolean>>;
  perpendicularGuideEnabled: boolean;
  setPerpendicularGuideEnabled: React.Dispatch<React.SetStateAction<boolean>>;
  showTriangleAngles: boolean;
  setShowTriangleAngles: React.Dispatch<React.SetStateAction<boolean>>;
  viewBox: ViewBox;
  setViewBox: React.Dispatch<React.SetStateAction<ViewBox>>;
  isSpacePressed: boolean;
  setIsSpacePressed: React.Dispatch<React.SetStateAction<boolean>>;
  isMouseDown: boolean;
  setIsMouseDown: React.Dispatch<React.SetStateAction<boolean>>;
  isShiftPressed: boolean;
  setIsShiftPressed: React.Dispatch<React.SetStateAction<boolean>>;
  isMetaPressed: boolean;
  setIsMetaPressed: React.Dispatch<React.SetStateAction<boolean>>;
  cursorPositionRef: React.MutableRefObject<Coordinate>;
  setCursorPosition: (coordinate: Coordinate) => void;
  snapPoints: Coordinate[];
  setSnapPoints: React.Dispatch<React.SetStateAction<Coordinate[]>>;
  snapLines: LineSegment[];
  setSnapLines: React.Dispatch<React.SetStateAction<LineSegment[]>>;
  commandManager: CommandManager;
  draggingDimensionId: string | null;
  setDraggingDimensionId: React.Dispatch<React.SetStateAction<string | null>>;
  pendingCount: number;
  isCanvasReady: boolean;
  loadProgress: number;
}

export const AppStateContext = createContext<IAppStateContext | undefined>(
  undefined
);
